<template>
  <b-modal
    modal-class="small-text"
    ref="AppointmentEditingHistoryModal"
    header-bg-variant="info"
    size="lg"
    title="ประวัติการแก้ไขนัดหมาย"
    hide-footer
  >
    <b-card no-body class="overflow-auto">
      <b-list-group flush>
        <b-list-group-item
          v-for="(entry, idx) in history"
          :key="idx"
          class="flex-column align-items-start p-2"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <span class="font-weight-bold">
              <i :class="iconClass(entry.type)"></i>
              {{ headline(entry) }}
            </span>
            <small class="text-muted">{{ formatDateTime(entry.at) }}</small>
          </div>

          <div v-if="entry.type === 'edit' && entry.changes" class="ml-3">
            <ul class="mb-0 pl-3">
              <li v-for="c in entry.changes" :key="c.field">
                <span class="font-weight-bold">{{ c.label }}:</span>
                <span v-if="formatValue(c.field, c.from) !== null" class="text-muted">{{ formatValue(c.field, c.from) }}</span>
                <i v-else class="text-muted font-italic">{{ EMPTY_LABEL }}</i>
                <i class="fas fa-arrow-right mx-1 text-muted"></i>
                <span v-if="formatValue(c.field, c.to) !== null">{{ formatValue(c.field, c.to) }}</span>
                <i v-else class="text-muted font-italic">{{ EMPTY_LABEL }}</i>
              </li>
            </ul>
          </div>
        </b-list-group-item>

        <b-list-group-item
          v-if="!isLoading && history.length === 0"
          class="flex-column align-items-start"
        >
          <p class="mb-0 text-muted">ยังไม่มีประวัติการแก้ไข</p>
        </b-list-group-item>

        <b-list-group-item
          v-if="isLoading"
          class="flex-column align-items-start text-center"
        >
          <p class="mb-0 text-muted">กำลังโหลด...</p>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </b-modal>
</template>

<script>
import moment from "moment";

const DATE_FIELDS = ["startDt", "endDt", "checkinDt", "treatmentDt"];
const EMPTY_LABEL = "(ไม่มีข้อมูล)";

const isEmpty = value =>
  value === null ||
  value === undefined ||
  value === "" ||
  (Array.isArray(value) && value.length === 0);

export default {
  name: "AppointmentEditingHistoryModal",
  data() {
    return {
      history: [],
      isLoading: false,
      EMPTY_LABEL,
    };
  },
  methods: {
    show(appointmentId) {
      this.history = [];
      this.isLoading = true;
      this.$refs.AppointmentEditingHistoryModal.show();
      this.$store
        .dispatch("moduleAppointment/fetchAppointmentEditingHistory", {
          id: appointmentId,
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        })
        .then(res => {
          this.history = res.data.history || [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    headline(entry) {
      const by = entry.by && entry.by.name ? entry.by.name : "ไม่ทราบผู้ใช้";
      switch (entry.type) {
        case "create":
          return `${by} สร้างนัดหมาย`;
        case "delete":
          return `${by} ลบนัดหมาย`;
        case "status": {
          const from = entry.from && entry.from.name ? entry.from.name : EMPTY_LABEL;
          const to = entry.to && entry.to.name ? entry.to.name : EMPTY_LABEL;
          return `${by} เปลี่ยนสถานะ: ${from} → ${to}`;
        }
        case "edit":
          return `${by} แก้ไขนัดหมาย`;
        default:
          return `${by} ${entry.type}`;
      }
    },
    iconClass(type) {
      switch (type) {
        case "create":
          return "fas fa-plus-circle text-success mr-1";
        case "delete":
          return "fas fa-trash text-danger mr-1";
        case "status":
          return "fas fa-exchange-alt text-info mr-1";
        case "edit":
          return "fas fa-pencil-alt text-warning mr-1";
        default:
          return "fas fa-circle mr-1";
      }
    },
    formatValue(field, value) {
      if (isEmpty(value)) return null;
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      if (DATE_FIELDS.includes(field)) {
        return moment(value).locale("th").format("L LT");
      }
      return value;
    },
    formatDateTime(value) {
      if (!value) return "";
      return moment(value).locale("th").format("L LT");
    },
  },
};
</script>
